export function buildCover({
  t,
  locale,
  companyName,
  brandName,
  logoUrl,
  bookingUrl,
  accent,
  modelType,
  recommendations,
}) {
  const recs = recommendations || {};
  const insight = recs.dimension_insight || {};
  const dim = String(insight.dimension || "").toLowerCase();
  const programs = (recs.programs || []).slice(0, 3).map((p) => {
    const tierKey = `tier.${p.tier_key}`;
    const tier = t(tierKey) === tierKey ? p.tier_label || "" : t(tierKey);
    const months = p.duration_months ? t("report.durationShort", { n: p.duration_months }) : "";
    return {
      tier,
      name: p.program_name || "",
      meta: [months, p.format].filter(Boolean).join(" · "),
    };
  });
  return {
    brandName,
    logoUrl,
    accent,
    locale,
    companyName: companyName || "",
    kicker: t("report.kicker"),
    subtitle: t("report.modelLine", { model: t(`model.${modelType}`) }),
    date: new Date().toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" }),
    readiness: recs.org_readiness_score ?? null,
    readinessLabel: t("report.orgReadiness"),
    insight: String(insight.text || "").trim(),
    insightLabel: ["mindset", "behavior", "outcome"].includes(dim) ? t(`dim.${dim}`) : t("dim.lagging"),
    programs,
    programsLabel: t("pdf.priorityPrograms"),
    bookingUrl: bookingUrl || "",
    bookingTitle: t("report.book"),
    bookingNote: t("pdf.bookingNote"),
    footer: t("pdf.coverFooter", { brand: brandName || "CoachMeUpp" }),
  };
}
